module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d6e983"
    }
  }, [_c('b', [_vm._v("The EVERYTHING"), _c('sub', [_vm._v("®")]), _vm._v(" Series ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e1073"
    }
  }, [_c('b', [_vm._v("Editorial ")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "1",
      "cellspacing": "1",
      "frame": "box",
      "rules": "all",
      "summary": "",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Publishing Director \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gary M. Krebs\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Managing Editor \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Kate McBride\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Copy Chief \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Laura MacLaughlin\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Acquisitions Editor \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bethany Brown\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Development Editor \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Karen Johnson Jacot\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Production Editor \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Khrysti Nazzaro"), _c('br'), _vm._v("Jamie Wielgus")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e1143"
    }
  }, [_c('b', [_vm._v("Production ")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "1",
      "cellspacing": "1",
      "frame": "box",
      "rules": "all",
      "summary": "",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Production Director \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Susan Beale\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Production Manager \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Michelle Roy Kelly\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Series Designers \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Daria Perreault"), _c('br'), _vm._v("Colleen Cunningham\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Cover Design \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Paul Beatrice"), _c('br'), _vm._v("Frank Rivera\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Layout and Graphics \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Colleen Cunningham"), _c('br'), _vm._v("Rachael Eiben"), _c('br'), _vm._v("Michelle Roy Kelly"), _c('br'), _vm._v("Daria Perreault"), _c('br'), _vm._v("Erin Ring\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Series Cover Artist \n")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Barry Littmann\n")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e1223"
    }
  }, [_c('b', [_vm._v("Visit the entire Everything "), _c('sup', [_vm._v("®")]), _vm._v(" Series at "), _c('a', {
    attrs: {
      "href": "http://everything.com",
      "id": "d14e168",
      "target": "_blank"
    }
  }, [_vm._v("everything.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e6d263","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sher_9781440522697_epub_c4_r1.vue
// module id = 69
// module chunks = 0